import * as def from '@/definitions'
import { ColorConstruct } from '@/utilityModels/colorConstruct'
import { Layer } from './layer';
import { ObjectLayer } from './objectLayer';
import { ArrayHelper } from '@/helper/arrayHelper';
import { FontManager } from '@/model/fontManager/fontManager';
import { TableCellInfo } from './table/tableCellInfo';
import { TableCellInfo2 } from './table/tableCellInfo2';

export class TableLayer extends ObjectLayer
{
    public get layerType() : string { return "table"; }

    public get layerVersion() { return 2; }

    // セル情報配列(２次元配列)
    private _cellInfoMap : Array<Array<TableCellInfo2>> = new Array();
    public get cellInfoMap() { return this._cellInfoMap; }
    public set cellInfoMap(cellInfoMap) { this._cellInfoMap = cellInfoMap; }

    // セル情報の取り出し
    public getCellInfo(row, column) { return this.cellInfoMap[row][column]; }
    // セル情報のセット
    public setCellInfo(row, column, info : TableCellInfo2) 
    {
        var newMap = new Array(); 
        for(var r = 0; r < this.row; ++r)
        {
            newMap.push(new Array());
            for(var c = 0; c < this.column; ++c)
            {
                var cloned = this.getCellInfo(r, c).clone();
                if(r == row && c == column)
                {
                    cloned = info;
                }
                newMap[r].push(cloned)
            }
        }
        this.cellInfoMap = newMap;
    }
    
    // 行数
    public get row() { return this.cellInfoMap.length; }
    // 列数
    public get column() { return this.cellInfoMap.length > 0 ? this.cellInfoMap[0].length : 0; }

    // 線色
    private _strokeColor : ColorConstruct = new ColorConstruct();
    public get strokeColor() { return this._strokeColor; }
    public set strokeColor(strokeColor) { this._strokeColor = strokeColor; }

    // 線幅
    private _strokeWidth : number = 0.5;
    public get strokeWidth() { return this._strokeWidth; }
    public set strokeWidth(strokeWidth) { this._strokeWidth = strokeWidth; }

    // 最後に触れたセル
    public touchedRow = -1;
    public touchedColumn = -1;
    // 現在の選択セル
    public currentRow = -1;
    public currentColumn = -1;

    public getInitialCellInfo()
    {
        if(0 < this.row && 0 < this.column)
        {
            return this.getCellInfo(0, 0);
        }
        else
        {
            return new TableCellInfo2();
        }
    }

    public getCurrentCellInfo()
    {
        if(0 <= this.currentRow && this.currentRow < this.row && 0 <= this.currentColumn && this.currentColumn < this.column)
        {
            return this.getCellInfo(this.currentRow, this.currentColumn);
        }
        else
        {
            return new TableCellInfo2();
        }
    }

    // 作成
    public static create(x : number, y : number, width : number, height : number, row : number, column : number) : TableLayer
    {
        var layer = new TableLayer();
        layer.x = x;
        layer.y = y;
        layer.width = width;
        layer.height = height;

        // セル作成
        for(var r = 0; r < row; ++r)
        {
            layer.cellInfoMap.push(new Array());
            for(var c = 0; c < column; ++c)
            {
                let tableCellInfo = new TableCellInfo2();
                tableCellInfo.cellWidthNormalized = 100 / column;
                tableCellInfo.cellHeightNormalized = 100 / row;
                layer.cellInfoMap[r].push(tableCellInfo);
            }
        }

        return layer;
    }

    // カレンダー作成
    // public static createCalendar(...)

    // 複製
    public clone()
    {
        var cloned = new TableLayer();
        this.cloneParameter(cloned);
        return cloned;
    }

    public cloneParameter(layer : TableLayer)
    {
        for(var r = 0; r < this.row; ++r)
        {
            layer.cellInfoMap.push(new Array());
            for(var c = 0; c < this.column; ++c)
            {
                layer.cellInfoMap[r].push(this.cellInfoMap[r][c]);
            }
        }
        layer.strokeColor = this._strokeColor.clone();
        layer.strokeWidth = this._strokeWidth;
        
        super.cloneParameter(layer);
    }

    // JSON
    public toJSON()
    {
        var jsonObj = {};
        jsonObj = this.saveParameterToJson(jsonObj);
        return jsonObj;
    }

    public saveParameterToJson(jsonObject)
    {
        jsonObject.cellInfoMap = this._cellInfoMap;
        jsonObject.strokeColor = this._strokeColor;
        jsonObject.strokeWidth = this._strokeWidth; 

        jsonObject.layerVersion = this.layerVersion;

        jsonObject = super.saveParameterToJson(jsonObject);

        return jsonObject;
    }

    public static createFromJsonData(jsonData : any) : TableLayer
    {
        var layer = new TableLayer();
        layer.loadParameterFromJson(jsonData);
        return layer;
    }

    public loadParameterFromJson(jsonData)
    {
        if(jsonData.cellInfoMap != null) 
        { 
            for(var r = 0; r < jsonData.cellInfoMap.length; ++r)
            {
                this._cellInfoMap.push(new Array());
                for(var c = 0; c < jsonData.cellInfoMap[r].length; ++c)
                {
                    this.cellInfoMap[r][c] = TableCellInfo2.createFromJsonData(jsonData.cellInfoMap[r][c]);
                }
            }
        }
        if(jsonData.strokeColor != null) { this._strokeColor = ColorConstruct.createFromJsonData(jsonData.strokeColor); }
        if(jsonData.strokeWidth != null) { this._strokeWidth = jsonData.strokeWidth; }
        
        super.loadParameterFromJson(jsonData);
    }
}